import React, { useState } from 'react';

import EditProfileForm from 'app/components/profile/EditProfileForm';
import clsx from 'clsx';
import { PROFILE_EDIT_TYPE } from 'app/constants/profile';

const EditProfilePage = (props: { onViewProfileClick: () => void }) => {
  const { onViewProfileClick } = props;
  const [editType, setEditType] = useState(PROFILE_EDIT_TYPE.BASIC);

  return (
    <>
      <div className="flex flex-col gap-3 lg:w-[353px] w-full">
        <div className="p-4 rounded bg-white h-fit">
          <div className="flex flex-col gap-4">
            <p className="text-base font-bold">Edit Profile</p>
            <div className="flex flex-col gap-3">
              <span
                className={clsx(
                  'text-sm font-bold cursor-pointer',
                  editType === PROFILE_EDIT_TYPE.BASIC
                    ? 'text-blue-500'
                    : 'text-neutral-500',
                )}
                onClick={() => setEditType(PROFILE_EDIT_TYPE.BASIC)}
              >
                Basic Information
              </span>
              <span
                className={clsx(
                  'text-sm font-bold cursor-pointer',
                  editType === PROFILE_EDIT_TYPE.PICTURE
                    ? 'text-blue-500'
                    : 'text-neutral-500',
                )}
                onClick={() => setEditType(PROFILE_EDIT_TYPE.PICTURE)}
              >
                Profile Picture
              </span>
            </div>
          </div>
        </div>
        <div className="p-4 rounded bg-white text-center h-fit">
          <span
            className="text-base font-bold cursor-pointer"
            onClick={onViewProfileClick}
          >
            View Profile
          </span>
        </div>
      </div>
      <div className="flex flex-col lg:w-[660px] w-full lg:ml-2.5 ml-0">
        <div className="p-4 rounded bg-white h-fit">
          <EditProfileForm editType={editType} />
        </div>
      </div>
    </>
  );
};

export default EditProfilePage;
